import { useCallback,useEffect, useState } from 'react';

import { useAppDispatch } from 'app/hooks';
import { setRows } from 'common/components/PalmDataGrid/palmDataGridSlice';
import { fetchUserGroupAclEntriesDetails } from 'common/services/api/Acls/AclEntries.thunk';
import { extractStatusCode } from 'common/services/api/apiHelpers';
import { handleListFetchError } from 'common/utils/errorHandlers';
import { useSnackbar } from 'notistack';

export const useFetchUserGroupAclEntriesDetailsWithLicenseInfo = (item: {
	tenantId: string,
	usergroupId?: string,
	userId?: string,
	isLicenseRequired?: boolean
}) => {
    const [processing, setProcessing] = useState<boolean>(false);
    const dispatch = useAppDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { tenantId, userId, usergroupId, isLicenseRequired } = item;

    const fetchUserGroupAclEntriesDetailsWithLicenseInfo = useCallback(() => {
        setProcessing(true);
        dispatch(fetchUserGroupAclEntriesDetails({ tenantId, usergroupId, userId }))
            .unwrap()
            .then((response) => {
                dispatch(setRows(response));
            })
            .catch((error) => {
                dispatch(setRows([]));
                handleListFetchError(extractStatusCode(error.message), 'ACL Entries', enqueueSnackbar);
            })
            .finally(() => {
                setProcessing(false);
            });
    }, [tenantId, usergroupId, userId, isLicenseRequired]);


    useEffect(() => {
        if(isLicenseRequired) {
            fetchUserGroupAclEntriesDetailsWithLicenseInfo();
        }
    }, [fetchUserGroupAclEntriesDetailsWithLicenseInfo, isLicenseRequired]);

    const refreshUserGroupAclEntriesDetailsWithLicenseInfo = () => fetchUserGroupAclEntriesDetailsWithLicenseInfo();

    return {
        userGroupAclEntriesWithLicenseInfoProcessing: processing,
        refreshUserGroupAclEntriesDetailsWithLicenseInfo
    };
};
